import Header from "../components/Header";
import Footer from "../components/Footer";
import SEOHead from "../components/SEOHead";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <SEOHead 
        title="Política de Privacidade"
        description="Política de Privacidade do FinaNews - Como coletamos, usamos e protegemos suas informações."
      />
      <Header onSearch={() => {}} />
      
      <main className="max-w-4xl mx-auto px-6 md:px-12 py-12">
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-slate-900 mb-8">
          Política de Privacidade
        </h1>
        
        <div className="prose prose-lg max-w-none text-slate-700 space-y-6">
          <p className="text-lg">
            Última atualização: {new Date().toLocaleDateString('pt-BR')}
          </p>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">1. Informações que Coletamos</h2>
            <p>
              Coletamos informações que você nos fornece diretamente, incluindo:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Endereço de email (ao se inscrever em nossa newsletter)</li>
              <li>Preferência de idioma</li>
              <li>Dados de uso e análise</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">2. Como Usamos suas Informações</h2>
            <p>
              Usamos as informações que coletamos para:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Enviar nossa newsletter com atualizações de notícias financeiras</li>
              <li>Melhorar nossos serviços e experiência do usuário</li>
              <li>Analisar o uso e tendências do site</li>
              <li>Cumprir obrigações legais</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">3. Cookies e Rastreamento</h2>
            <p>
              Usamos cookies e tecnologias de rastreamento semelhantes para melhorar sua experiência de navegação. 
              Você pode controlar os cookies através das configurações do seu navegador.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">4. Serviços de Terceiros</h2>
            <p>
              Podemos usar serviços de terceiros para análise e publicidade, incluindo o Google AdSense. 
              Esses serviços podem coletar informações sobre suas visitas ao nosso site.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">5. Segurança de Dados</h2>
            <p>
              Implementamos medidas de segurança apropriadas para proteger suas informações pessoais. 
              No entanto, nenhum método de transmissão pela internet é 100% seguro.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">6. Seus Direitos</h2>
            <p>
              Você tem o direito de:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Acessar seus dados pessoais</li>
              <li>Solicitar correção de seus dados</li>
              <li>Solicitar exclusão de seus dados</li>
              <li>Cancelar a inscrição de nossa newsletter a qualquer momento</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mt-8 mb-4">7. Contate-nos</h2>
            <p>
              Se você tiver alguma dúvida sobre esta Política de Privacidade, entre em contato conosco através do nosso site.
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;